<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<div class="nps" *ngIf="exibirNPSEcommerce || exibirNPSLoja">
  <div class="nps__modal animated fadeIn" *ngIf="exibirNPSEcommerce">
    <div class="modal__header">
      <span
        class="fa fa-times-circle header__close"
        (click)="fecharPopupEcommerce()"
      ></span>
    </div>
    <div class="modal__body">
      <div class="perguntas">
        <div class="pergunta">
          <p class="cs_label label__pergunta">
            Como você avalia sua última experiência com o Ecommerce?
          </p>
          <p class="cs_label label__lojas">https://www.cacaushow.com.br/</p>
          <div class="pergunta__avaliacao">
            <div
              class="avaliacao__nota"
              *ngFor="let nota of notas"
              (click)="selecionarNotaEcommerce(nota)"
            >
              <p>{{ nota }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__footer"></div>
  </div>

  <div class="nps" *ngIf="exibirNPSLoja">
    <div class="nps__modal animated fadeIn">
      <div class="modal__header">
        <span
          class="fa fa-times-circle header__close"
          (click)="fecharPopupLoja()"
        ></span>
      </div>
      <div class="modal__body">
        <div class="perguntas">
          <div class="pergunta">
            <p class="cs_label label__pergunta">
              Como você avalia
              {{
                "sua última experiência nas loja" | singularPlural: lojas.length
              }}
            </p>
            <p class="cs_label label__lojas" *ngFor="let loja of lojas">
              {{ loja }}
            </p>
            <div class="pergunta__avaliacao">
              <div
                class="avaliacao__nota"
                *ngFor="let nota of notas"
                (click)="selecionarNotaLoja(nota)"
              >
                <p>{{ nota }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__footer"></div>
    </div>
  </div>
</div>
